import ServicePageTemplate from '../ServicePageTemplate';
import { homeFaqs } from '../../../mocks/faqs';

export default function RetainingWalls() {
  return (
    <ServicePageTemplate
      heroTitle="Retaining Wall Construction"
      heroSubtitle="Structurally sound retaining walls that manage grade changes, prevent erosion, and add architectural beauty to your landscape."
      heroImage="https://www.parksidepavers.com/files/projects/16/images/thumb/thumb_large_IMG%5F2840%2Ejpg"
      serviceBreakdownTitle="Our Retaining Wall Services"
      serviceBreakdown={[
        { title: 'Segmental Retaining Walls', desc: 'Interlocking block walls engineered for strength and long-term stability.', icon: 'ri-layout-column-line' },
        { title: 'Landscape Terracing', desc: 'Multi-level terraced walls that transform sloped yards into usable outdoor space.', icon: 'ri-mountain-line' },
        { title: 'Decorative Garden Walls', desc: 'Low-height garden walls that define planting areas and add visual interest.', icon: 'ri-plant-line' },
        { title: 'Erosion Control', desc: 'Structural walls designed to prevent soil erosion and protect your property.', icon: 'ri-shield-check-line' },
      ]}
      aiAnswerText="Retaining wall construction requires proper engineering, material selection, and installation to ensure long-term structural integrity. Parkside Pavers builds retaining walls using segmental block systems designed to handle the soil pressure and drainage requirements of each unique site. Whether you need a small garden border or a large structural wall, our team delivers results that are both functional and visually impressive."
      aiAnswerBenefits={[
        'Prevents soil erosion & shifting',
        'Creates usable terraced areas',
        'Adds architectural appeal',
        'Properly engineered drainage',
        'Built to last in Florida climate',
        'Residential & commercial scale',
      ]}
      faqs={[
        { question: 'Do I need a permit for a retaining wall?', answer: 'It depends on the height and location of the wall. Parkside Pavers can advise you during your free consultation on whether your project requires permitting in your specific city or county.' },
        { question: 'How long do retaining walls last?', answer: 'Properly built segmental retaining walls can last 50+ years with minimal maintenance. Key factors include proper drainage behind the wall, a solid compacted base, and quality materials — all of which Parkside Pavers prioritizes.' },
        ...homeFaqs.slice(3),
      ]}
      seoCity="Tampa Bay"
    />
  );
}
